export default __webpack_public_path__ + "img/dcf8a5ce0a1ec7e41f701cf667265927.jpg";